






import Vue from 'vue'
import { mapState } from 'vuex'
import { CLASSIFIED_SEARCH_NS } from '~/store/modules/shared/classifieds/search/state'
import MapSearch from '~/components/car/classifieds/search/map-search/MapSearch.vue'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import SearchService from '~/services/search/SearchService'

export default Vue.extend({
  name: 'MapSearchPage',
  components: { MapSearch },
  async fetch() {
    const isMobile = this.$store.getters[`${USER_AGENT_NS}/isMobile`]
    const searchService = this.$dep(SearchService)
    if (isMobile && this.$route.params.slugOrId) {
      this.$router.push(`/${this.$route.params.slugOrId}`)
    }
    if (!this.search) {
      await searchService.createSearch({
        route: this.$route,
        mapSearch: true,
        errorFn: this.$error
      })
      this.search = true
    }
  },
  data() {
    return {
      isMapSearchActive: true,
      search: null
    }
  },
  computed: {
    ...mapState(CLASSIFIED_SEARCH_NS, ['searchId'])
  },
  deactivated() {
    if (this.$route.name === '__index') {
      this.isMapSearchActive = false
      this.search = null
    }
  },
  activated() {
    this.isMapSearchActive = true
    if (!this.search) {
      this.$fetch()
    }
  },
  head() {
    const headService = this.$dep(SearchService)
    return headService.createSearchHead(this.$route)
  }
})
